import { render, staticRenderFns } from "./DadosPrincipal.vue?vue&type=template&id=2ae17166&"
import script from "./DadosPrincipal.vue?vue&type=script&lang=js&"
export * from "./DadosPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports